import { DESIGNER_TOOLS, EXPRESSION_TYPES } from '@/consts'

export const ACTIVE_PROPERTIES_GROUP_NAME = 'active_properties'
export const SCHEMA_ATTRIBUTES = {
  DISABLED: 'disabled',
  READ_ONLY: 'readOnly',
  HIDDEN: 'hidden',
}
export const FORMULATE_INPUT_TYPES = {
  EL_BUTTON: 'el-button',
  EL_CHECKBOX: 'el-checkbox',
  EL_NUMBER: 'el-number',
  EL_SELECT: 'el-select',
  EL_TEXT: 'el-text',
  BOOL_OR_EXP: 'bool-or-exp',
  GROUPED: 'grouped-inputs',
  LIST_SOURCE: 'list-source',
  LOCALIZED_TEXT: 'localized-text',
  LOCALIZATION_LIST: 'localization-list',
  SUB_FORM_PICKER: 'sub-form-picker',
  COMPUTED: 'computed-field',
  PLACEHOLDER: 'placeholder-picker',
  FILESIZE_INPUT: 'filesize-input',
  FORM_AND_TABLE: 'form-and-table',
  FILTER_BUILDER: 'filter-builder',
  PREFIX_ICON: 'icon-selector',
  SQL_CHOSEN_OPTIONS: 'sql-chosen-options',
  COLUMN_OVERRIDES: 'column-overrides',
  MENU_ASSIGNER: 'menu-assigner',
  TIME_SELECT_FORM: 'time-select-form',
} as const
  export const FORMULATE_PROP_FIELD_TYPES = {
  TEXTAREA: 'textarea',
  SWITCH: 'switch',
  EXPRESSION: 'exp',
}
export const FORMULATE_VALIDATION_TYPES = {
  BAIL: 'bail',
  REQUIRED: 'required',
  FORM_NAME_CHECK: 'form-name-check',
  VALIDATION_MIN_VALUE_CHECK: 'validation-min-value-check',
  VALIDATION_MIN_LENGTH_CHECK: 'validation-min-length-check',
  VALIDATION_MAX_VALUE_CHECK: 'validation-max-value-check',
  VALIDATION_MAX_LENGTH_CHECK: 'validation-max-length-check',
  VALIDATION_DECIMAL_CHECK: 'validation-decimal-check',
  VALIDATION_LIST_EXP: 'validation-list-exp',
  VALIDATION_LIST_SOURCE_FORM_ID: 'validation-rel-form-id',
  VALIDATION_LIST_SOURCE_FIELD: 'validation-rel-field',
  VALIDATION_COLUMN_OVERRIDES_UNIQUE_SEQ: 'validation-overrides-unique',
  VALIDATION_COLUMN_OVERRIDES_REQUIRED_COLUMNS: 'validation-overrides-required',
  UNIQUE_BOOLEAN_TRUE: 'unique-boolean-true',
  UNIQUE_FIELD_NAME: 'unique-field-name',
  TIME_FORMAT_24: 'time-format-24',
}
export const FORMULATE_PROPS = {
  ERROR_BEHAVIOUR: 'error-behavior',
  VALIDATION_RULES: 'validation-rules',
  VALIDATION_MESSAGES: 'validation-messages',
  HELP_POSITION: 'help-position',
}
export const FORMULATE_PROP_VALUES = {
  LIVE: 'live',
  DEFAULT: 'default',
  BEFORE: 'before',
  AFTER: 'after',
}
// El-selectnek lehet ezzel kezdodo pathArray-t adni, ha adott formon masik property-re, vagy state-ben levo propertyre akarunk watchot
// az El-selecben ezek computed-ek
export const STATE_PROPERTIES = {
  ACTIVE_PROPERTY: 'activeProperty',
  ACTIVE_FORM_DATA: 'formData',
  STATE: 'state',
}
export const FIELD_PROPERTY_TYPES = {
  EXPRESSION: 'exp',
  BOOLEAN: 'boolean',
  STRING: 'string',
}
export const DESIGNER_CLASSES = {
  WRAPPER: 'designer-input dynamic-wrapper',
  INPUT_SMALL: 'designer-input small',
  EXPRESSION_GRID: 'designer-input expression-grid',
  CHECKBOX: 'designer-input designer-checkbox',
}
export const ELEMENT_COMPONENT_SIZES = {
  MINI: 'mini',
  SMALL: 'small',
  MEDIUM: 'medium',
}
export const ELEMENT_COMPONENT_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  TEXT: 'text',
}
export const FORM_SCHEMA_TYPES = {
  FORM: 'form',
  PAGE: 'page',
  GROUP: 'group',
  FIELD: 'field',
  VALIDATION: 'validation',
  PROPERTY: 'property',
} as const
  export const LIST_SOURCE_TYPES = {
  FORM: 'form',
  EXPRESSION: 'expression',
}
export const CAPTCHA_TYPES = {
  SPARTAN: 'captcha',
  RE_CAPTCHA: 'recaptcha',
}
export const SQL_CHOSEN_OPTIONS = [
  'showSelectionColumn',
  'showCreateDate',
  'showCreateUser',
  'showListOnStart',
  'showPageLimiter',
  'showPagination',
]
export const ICONS_PREFIX = 'material-symbols-light:'
export const VIEWS = {
  [DESIGNER_TOOLS.PALETTE]: {
    icon: `${ICONS_PREFIX}palette-outline`,
    title: 'form_designer_palette_label',
  },
  form: {
    icon: `${ICONS_PREFIX}settings-outline-rounded`,
    title: 'form_designer_form_properties',
  },
  group: {
    icon: `${ICONS_PREFIX}ad-group-outline`,
    title: 'form_designer_group_properties',
  },
  field: {
    icon: `${ICONS_PREFIX}display-settings-outline-rounded`,
    title: 'form_designer_field_properties',
  },
  page: {
    icon: `${ICONS_PREFIX}desktop-landscape-outline-rounded`,
    title: 'form_designer_page_properties',
  },
  [DESIGNER_TOOLS.ENUM_MANAGER]: {
    icon: `${ICONS_PREFIX}data-table-outline-rounded`,
    title: 'form_designer_enum_manager',
  },
  [DESIGNER_TOOLS.FIELD_IMPORTER]: {
    icon: `${ICONS_PREFIX}system-update-alt-rounded`,
    title: 'form_designer_field_importer',
  },
  [DESIGNER_TOOLS.MANAGER_MODE]: {
    icon: `${ICONS_PREFIX}sort-rounded`,
    title: 'form_designer_sort_pages_groups',
  },
  [DESIGNER_TOOLS.GUI_SETTINGS]: {
    icon: `${ICONS_PREFIX}display-settings-outline-rounded`,
    title: 'form_designer_gui_settings',
  },
  [DESIGNER_TOOLS.VERIFICATIONS]: {
    icon: `${ICONS_PREFIX}shield-outline-rounded`,
    title: 'form_designer_verifications',
  },
  [DESIGNER_TOOLS.GENERATE_FIELDS]: {
    icon: `${ICONS_PREFIX}star-outline-rounded`,
    title: 'form_designer_generate_fields_with_ai',
  },
  [DESIGNER_TOOLS.DESIGNER_FINDER]: {
    icon: `${ICONS_PREFIX}search-rounded`,
    title: 'form_designer_find',
  },
  [DESIGNER_TOOLS.FILTER_BUILDER]: {
    icon: `${ICONS_PREFIX}filter-alt-outline`,
    title: 'form_designer_filter_builder',
  },
}
export const ONE_ROW_CHECKBOX_CLASSNAME = ' flex-row'
export const FIELDS_PREFIX = 'form_designer_field_'
export const EXPRESSION_TYPE_ICON_MAP = {
  [EXPRESSION_TYPES.READ_ONLY]: `${ICONS_PREFIX}lock-outline-sharp`,
  [EXPRESSION_TYPES.HIDDEN]: `${ICONS_PREFIX}visibility-outline-rounded`,
  [EXPRESSION_TYPES.VALUE]: `${ICONS_PREFIX}attach-money`,
  [EXPRESSION_TYPES.LABEL]: `${ICONS_PREFIX}label-important-outline-rounded`,
  [EXPRESSION_TYPES.REQUIRED]: `${ICONS_PREFIX}label-important-outline-rounded`,
}
export const LIST_EXPRESSION_WARNING_MESSAGE = 'form_designer_only_use_list_expression_if_its_necessary'
export const FILTER_EXPRESSION_WARNING_MESSAGE = 'filter_expression_is_deprecated'
export const FORM_DESIGNER_DIRTY_INFO_MESSAGE = 'form_designer_unable_to_save_form_is_untouched'
export const MESSAGE_SEVERITIES = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
}
export const FORM_DESIGNER_DIRTY_MESSAGE_ID = 'form:dirty'
export const FORM_DESIGNER_UNIQUE_TRUE_MESSAGE_ID = 'unique-boolean-field:'
export const GENERATED_LOCALIZATION_REGEX = /^(\w+)-(\w+)-(\w+)-(\w+)$/ // A generált localization kulcsot ellenőrzi pl: "valami-valami-valami-valami"
